import { useState } from 'react';
import NavBar from './NavBar';
import Display from './Display';

// Two routes render this: `/` opens on the pitch, `/explore` opens on the
// generator already running. They are the same page because they are the same
// place — the difference is only whether the visitor still needs convincing.
//
// It also brokers the generator's Back control. The zoom history lives in Display
// and the control lives in NavBar, which are siblings, so Home holds the wire
// between them. Passed on only when exploring: on the pitch there is no history to
// step back through.
const Home = ({ explore = false }) => {

    const [history, setHistory] = useState({ canGoBack: false, goBack: null });

    return (
        <div className="App-header">
            <NavBar
                canGoBack={explore && history.canGoBack}
                onBack={history.goBack}
            />
            <div className="generator-display">
                <Display explore={explore} onHistoryChange={setHistory} />
            </div>
        </div>
    );
};

export default Home;
